import { Account } from './account';
import { AclEntry } from './acl-entry';
import { AclRole } from './acl-role';
import { Environment } from './environment';


export interface EnvironmentAccount {
  readonly id: number;
  accountId?: number;
  account?: Account;
  environmentId?: number;
  environment?: Environment;
  createDate?: string;
  state?: string;
  signinDate?: string;
  aclEntries?: AclEntry[];
  aclRoles?: AclRole[];
}
